import { SEGMENT_NAMES } from '~/constants';
import { useAppDispatch } from '~/store';
import { OldUploadNotifiers } from '~/uploads/types';
import { actions } from './reducer';

export const useStoryGroupNotifiers = (): OldUploadNotifiers => {
  const dispatch = useAppDispatch();

  const trackAspectRatio = ({ width, height, id }) => {
    dispatch(
      actions.trackAspectRatio({
        width,
        height,
        cta: SEGMENT_NAMES.STORIES_IMAGE_ASPECT_RATIO_UPLOADED,
        id,
      })
    );
  };

  const notifiers: OldUploadNotifiers = {
    uploadStarted: ({ id, uploaderInstance, file, source }) =>
      dispatch(
        actions.createNewStoryCard({ id, uploaderInstance, file, source })
      ),
    uploadedDraftImage: ({
      id,
      uploaderInstance,
      url,
      width,
      height,
      file,
      source,
    }) => {
      dispatch(
        actions.uploadImageComplete({
          id,
          uploaderInstance,
          url,
          width,
          height,
          file,
          source,
          contentType: 'image',
        })
      );
      trackAspectRatio({ width, height, id });
    },
    uploadedDraftVideo: ({ id, uploaderInstance, uploadId, file }) => {
      dispatch(
        actions.videoUploadProcessingStarted({
          id,
          uploaderInstance,
          uploadId,
          file,
          contentType: 'video',
        })
      );
    },
    draftGifUploaded: ({
      id,
      uploaderInstance,
      url,
      width,
      height,
      file,
      stillGifUrl,
      source,
    }) => {
      dispatch(
        actions.uploadImageComplete({
          id,
          uploaderInstance,
          url,
          width,
          height,
          file,
          stillGifUrl,
          source,
          contentType: 'gif',
        })
      );
      trackAspectRatio({ width, height, id });
    },
    queueError: ({ message }: { message: string }) => {
      dispatch(actions.showError({ message }));
    },
    updateFileUploadProgress: ({
      id,
      uploaderInstance,
      progress,
      complete,
    }) => {
      dispatch(
        actions.updateStoryUploadProgress({
          id,
          uploaderInstance,
          progress,
          complete,
        })
      );
      actions.updateStoryPogress(dispatch);
    },
  };

  return notifiers;
};
